import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useModalsContext } from '../../providers/ModalsProvider/Modals.context';
import { RouterPaths } from '../Router/Router.constants';
import ChatModal from './ChatModal.component';

/**
 * The chat popup's mount for every private route (AGI-761). A leaf of its own so
 * the layout shell never subscribes to ModalsContext, whose ~50 flags would
 * re-render the whole shell on any modal toggle.
 */
export default function GlobalChatModal() {
  const {
    chatModalIsOpen,
    setChatModalIsOpen,
    setMaximizeModal,
    selectedLeadForChatModal,
    setSelectedLeadForChatModal,
  } = useModalsContext();
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  // An open popup never outlives the page it opened over (Back, a link, entering
  // /workspace/chat): close it and drop its lead, or the Pipe and Directory auto-open
  // effects would bring it back for the old lead. A closed popup's lead is left alone,
  // so /workspace/chat keeps handing its lead to the next page as before.
  useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    if (!chatModalIsOpen) return;
    setChatModalIsOpen(false);
    setMaximizeModal(false);
    setSelectedLeadForChatModal(null);
    // Only a route change closes it; the setters are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // The chat page shows the chat itself (a link switches it in place), and the Pipe
  // mounts the popup inside its own provider.
  const pageOwnsChat = pathname.startsWith(RouterPaths.chat) || pathname.startsWith(RouterPaths.pipe);

  // No lead, no popup: an auto-open effect racing the reset above may still set it open.
  return chatModalIsOpen && selectedLeadForChatModal && !pageOwnsChat ? <ChatModal /> : null;
}
